/**
 * Cross-fading testimonials (sections/testimonials.liquid).
 *
 * Only the `is-active` slide is in the flow, so the block takes its height;
 * the CSS fades between slides and this file animates the height. It moves
 * `is-active` on the arrows, on a horizontal swipe, and in the theme editor
 * when a testimonial block is selected. The arrows loop, so neither is ever disabled. Without this file
 * the first testimonial shows and the nav stays hidden.
 */
(function () {
  'use strict';

  var SWIPE_MIN = 40;

  function init(root) {
    if (!root || root.hasAttribute('data-testimonials-ready')) {
      return;
    }

    var track = root.querySelector('[data-testimonials-track]');
    var nav = root.querySelector('[data-testimonials-nav]');
    if (!track) {
      return;
    }

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-testimonials-slide]'));
    if (slides.length < 2) {
      return;
    }

    root.setAttribute('data-testimonials-ready', 'true');
    if (nav) {
      nav.hidden = false;
    }

    var current = Math.max(
      0,
      slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      })
    );

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // The track follows the active slide's height. To animate it, pin the
    // current height, swap slides, then set the new one; the CSS transitions
    // between the two and the inline height is dropped once it lands.
    function clearHeight(event) {
      if (event && (event.target !== track || event.propertyName !== 'height')) {
        return;
      }
      track.style.height = '';
    }
    track.addEventListener('transitionend', clearHeight);
    var settle = null;

    function show(index) {
      var next = (index + slides.length) % slides.length;
      if (next === current) {
        return;
      }
      var from = track.offsetHeight;
      current = next;
      if (!reduceMotion.matches) {
        track.style.height = from + 'px';
      }
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      if (!reduceMotion.matches) {
        var to = slides[current].offsetHeight;
        if (to === from) {
          clearHeight();
        } else {
          track.style.height = to + 'px';
          // If transitionend never arrives (a background tab, an interrupted
          // transition), still let go of the pinned height.
          window.clearTimeout(settle);
          settle = window.setTimeout(clearHeight, 700);
        }
      }
    }

    if (nav) {
      var prev = nav.querySelector('[data-testimonials-prev]');
      var next = nav.querySelector('[data-testimonials-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          show(current - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          show(current + 1);
        });
      }
    }

    // Touch: a mostly horizontal swipe changes testimonial; vertical scrolling
    // is left alone.
    var startX = null;
    var startY = null;
    track.addEventListener(
      'touchstart',
      function (event) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );
    track.addEventListener(
      'touchend',
      function (event) {
        if (startX === null) {
          return;
        }
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) > SWIPE_MIN && Math.abs(dx) > Math.abs(dy)) {
          show(dx < 0 ? current + 1 : current - 1);
        }
      },
      { passive: true }
    );

    // Theme editor: show the testimonial whose block was selected.
    root.addEventListener('shopify:block:select', function (event) {
      var index = slides.indexOf(event.target.closest('[data-testimonials-slide]'));
      if (index > -1) {
        show(index);
      }
    });
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.forEach.call(container.querySelectorAll('[data-testimonials]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
